<template>
  <div class="agent-commission">
    <div class="commission-header">
      <h2>佣金记录</h2>
      <div class="date-filter">
        <input type="date" v-model="startDate" @change="handleQuery">
        <span class="date-separator">至</span>
        <input type="date" v-model="endDate" @change="handleQuery">
        <button class="filter-btn" @click="handleQuery">查询</button>
      </div>
    </div>

    <div class="commission-stats">
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalRecharge }}</div>
        <div class="stat-label">总存款</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalWithdraw }}</div>
        <div class="stat-label">总提款</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalValidBet }}</div>
        <div class="stat-label">总有效投注</div>
      </div>
      <div class="stat-item">
        <div class="stat-value" :class="winLossClass(stats.totalWinLoss)">{{ stats.totalWinLoss }}</div>
        <div class="stat-label">总输赢</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalFanshui }}</div>
        <div class="stat-label">总返水</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalRedpacket }}</div>
        <div class="stat-label">总红包</div>
      </div>
      <div class="stat-item highlight">
        <div class="stat-value">{{ stats.totalCommission }}</div>
        <div class="stat-label">已结算佣金</div>
      </div>
      <div class="stat-item pending">
        <div class="stat-value">{{ stats.waitCommission }}</div>
        <div class="stat-label">待领取佣金</div>
      </div>
    </div>

    <!-- 领取佣金 -->
    <div class="claim-section">
      <div class="claim-info">
        <span class="claim-tip">待领取佣金将结算到您的账户余额</span>
        <span class="claim-amount" v-if="stats.waitCommission > 0">￥{{ stats.waitCommission }}</span>
      </div>
      <button
        class="claim-btn"
        :disabled="claiming || stats.waitCommission <= 0"
        @click="claimCommission"
      >{{ claiming ? '领取中...' : '领取佣金' }}</button>
    </div>

    <div class="commission-content">
      <div class="list-title">佣金明细</div>

      <div class="commission-table" v-if="commissions.length > 0">
        <div class="table-header">
          <span class="col-date">时间</span>
          <span class="col-platform">平台</span>
          <span class="col-amount">佣金金额</span>
          <span class="col-status">状态</span>
        </div>
        <div class="table-row" v-for="item in commissions" :key="item.id">
          <span class="col-date">{{ item.date }}</span>
          <span class="col-platform">{{ item.platform }}</span>
          <span class="col-amount">+{{ item.amount }}</span>
          <span class="col-status" :class="item.status === '已结算' ? 'settled' : 'pending'">{{ item.status }}</span>
        </div>
      </div>

      <div class="no-data" v-else>暂无佣金记录</div>

      <div class="pagination" v-if="totalPages > 1">
        <button class="page-btn" @click="changePage(1)" :disabled="currentPage === 1">首页</button>
        <button class="page-btn" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">上一页</button>
        <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页</span>
        <button class="page-btn" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">下一页</button>
        <button class="page-btn" @click="changePage(totalPages)" :disabled="currentPage === totalPages">末页</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agentCommission',
  data() {
    return {
      startDate: '',
      endDate: '',
      stats: {
        totalRecharge: 0,
        totalWithdraw: 0,
        totalValidBet: 0,
        totalWinLoss: 0,
        totalFanshui: 0,
        totalRedpacket: 0,
        totalCommission: 0,
        waitCommission: 0
      },
      commissions: [],
      currentPage: 1,
      totalPages: 1,
      claiming: false
    };
  },
  created() {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);
    this.startDate = sevenDaysAgo.toISOString().split('T')[0];
    this.endDate = today.toISOString().split('T')[0];

    this.getCommissionStats();
    this.getCommissionList();
  },
  methods: {
    winLossClass(val) {
      if (val > 0) return 'win';
      if (val < 0) return 'loss';
      return '';
    },
    handleQuery() {
      this.currentPage = 1;
      this.getCommissionStats();
      this.getCommissionList();
    },
    getCommissionStats() {
      let that = this;
      let params = {
        start_date: this.startDate,
        end_date: this.endDate
      };
      this.$apiFun.get('/api/team/report', params).then(res => {
        if (res.code === 200) {
          that.stats = {
            totalRecharge: res.data.recharge || 0,
            totalWithdraw: res.data.withdrawal || 0,
            totalValidBet: res.data.validBet || 0,
            totalWinLoss: res.data.gameWinLoss || 0,
            totalFanshui: res.data.gameRebate || 0,
            totalRedpacket: res.data.activityBonus || 0,
            totalCommission: res.data.agentCommission || 0,
            waitCommission: res.data.waitCommission || 0
          };
        }
      }).catch(() => {
        that.stats = {
          totalRecharge: 0, totalWithdraw: 0, totalValidBet: 0,
          totalWinLoss: 0, totalFanshui: 0, totalRedpacket: 0,
          totalCommission: 0, waitCommission: 0
        };
      });
    },
    getCommissionList() {
      let that = this;
      let params = {
        page: this.currentPage,
        start_date: this.startDate,
        end_date: this.endDate
      };
      this.$apiFun.get('/api/team/commissionList', params).then(res => {
        if (res.code === 200) {
          that.commissions = res.data.data || [];
          that.totalPages = res.data.totalPages || 1;
        } else {
          that.commissions = [];
          that.totalPages = 1;
        }
      }).catch(() => {
        that.commissions = [];
        that.totalPages = 1;
      });
    },
    claimCommission() {
      if (this.stats.waitCommission <= 0) {
        this.showToast(0, '暂无可领取佣金');
        return;
      }
      this.claiming = true;
      this.$apiFun.post('/api/team/claimCommission', {}).then(res => {
        if (res.code === 200) {
          this.showToast(1, res.message || '领取成功');
          if (this.$root.getUserInfo) {
            this.$root.getUserInfo();
          }
          this.getCommissionStats();
          this.getCommissionList();
        } else {
          this.showToast(0, res.message || '领取失败');
        }
      }).catch(() => {
        this.showToast(0, '领取失败，请稍后重试');
      }).finally(() => {
        this.claiming = false;
      });
    },
    showToast(type, message) {
      if (this.$root.showTost) {
        this.$root.showTost(type, message);
      } else {
        alert(message);
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getCommissionList();
      }
    }
  }
};
</script>

<style scoped>
.agent-commission {
  padding: 15px;
  background: #f5f5f5;
  min-height: 100vh;
}

.commission-header {
  margin-bottom: 15px;
}

.commission-header h2 {
  margin: 0 0 12px;
  font-size: 18px;
  color: #333;
}

.date-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.date-filter input {
  flex: 1;
  min-width: 120px;
  padding: 8px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
}

.date-separator {
  color: #999;
  font-size: 14px;
}

.filter-btn {
  width: 100%;
  padding: 10px;
  background: #084ccb;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.commission-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 12px;
}

.stat-item {
  text-align: center;
  padding: 12px 6px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.stat-item.highlight .stat-value {
  color: #084ccb;
}

.stat-item.pending .stat-value {
  color: #cf866b;
}

.stat-value {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.stat-value.win { color: #ff4d4f; }
.stat-value.loss { color: #52c41a; }

.stat-label {
  font-size: 11px;
  color: #888;
}

.claim-section {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.claim-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.claim-tip {
  font-size: 13px;
  color: #888;
}

.claim-amount {
  font-size: 18px;
  font-weight: bold;
  color: #cf866b;
}

.claim-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(to right, #084ccb, #3a7bd5);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.claim-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.commission-content {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.list-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.table-header {
  display: grid;
  grid-template-columns: 1.4fr 0.8fr 1fr 0.8fr;
  gap: 6px;
  padding: 10px 8px;
  background: #f7f9fc;
  border-radius: 6px;
  font-size: 12px;
  color: #888;
}

.table-row {
  display: grid;
  grid-template-columns: 1.4fr 0.8fr 1fr 0.8fr;
  gap: 6px;
  padding: 12px 8px;
  border-bottom: 1px solid #f5f5f5;
  font-size: 13px;
  color: #333;
  align-items: center;
}

.table-row:last-child {
  border-bottom: none;
}

.col-amount {
  color: #cf866b;
  font-weight: 600;
}

.col-status.settled {
  color: #52c41a;
}

.col-status.pending {
  color: #faad14;
}

.no-data {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.page-btn {
  padding: 6px 12px;
  background: #f8f9fa;
  color: #333;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 13px;
  color: #666;
}

@media (max-width: 768px) {
  .commission-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .table-header {
    display: none;
  }

  .table-row {
    display: block;
    padding: 12px;
    margin-bottom: 10px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    background: #fafbfc;
  }

  .table-row span {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    font-size: 13px;
  }

  .table-row span::before {
    color: #999;
    font-size: 12px;
  }

  .col-date::before { content: '时间'; }
  .col-platform::before { content: '平台'; }
  .col-amount::before { content: '佣金金额'; }
  .col-status::before { content: '状态'; }
}
</style>



// WEBPACK FOOTER //
// src/components/agent/agentCommission.vue